<template>
  <div>
    <section
      class="box-detail form-detail"
      v-if="dataContract.groupService === 'SELL' && dataContract.formContract === 'E_CONTRACT'"
    >
      <h1>Phụ lục phần mềm</h1>
      <div class="table-responsive">
        <div class="table-responsive">
          <table class="table table-hover table-bordered">
            <thead class="thead-light">
              <tr>
                <th scope="col" class="text-left">Mã PL</th>
                <th scope="col" class="text-left">Thời gian</th>
                <th scope="col" class="text-left">Thời gian sử dụng</th>
                <th scope="col" class="text-left">Đơn giá</th>
                <th scope="col" class="text-left">Thành tiền</th>
                <th scope="col" class="text-left">Danh sách username</th>
                <th scope="col" class="text-left">Trạng thái</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in dataContract.lstAppendixPackages" :key="index">
              <tr class="table-row">
                <td align="left">{{ item.code }}</td>
                <td align="left">
                  <p v-if="item.dateCreatedAppendixDTO || item.dateCreate">
                    <b>Ngày tạo :</b>
                    {{
                      item.dateCreatedAppendixDTO
                        ? item.dateCreatedAppendixDTO
                        : item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                    }}
                  </p>
                  <p
                    v-if="
                      item.state &&
                      (item.state === 'SIGNED_WAITING_APPROVED' ||
                        item.state === 'APPROVED' ||
                        item.state === 'REJECTED_SA') &&
                      (item.dateSignAppendixDTO || item.dateSign)
                    "
                  >
                    <b>Ngày ký :</b>
                    {{
                      item.dateSignAppendixDTO
                        ? item.dateSignAppendixDTO
                        : item.dateSign | formatDate
                    }}
                  </p>
                  <p v-if="item.state && item.state === 'CANCELED' && item.dateCancelDTO">
                    <b>Ngày huỷ :</b> {{ item.dateCancelDTO | formatDate }}
                  </p>
                </td>
                <td align="left">
                  <template v-if="item.appendixPackage.name === 'Vĩnh Viễn'"> vĩnh viễn </template>
                  <template v-else>
                    {{ item.appendixPackage.number }} {{ item.appendixPackage.name }}
                  </template>
                </td>
                <td align="left">{{ item.appendixPackage.price | fomatCurrency }}</td>
                <td align="left">{{ item.appendixPackage.totalPrice | fomatCurrency }}</td>
                <td align="left">{{ item.appendixPackage.userNameStr }}</td>
                <td align="left">
                  <span class="f12 badge" v-bind:class="[item.state ? item.state : '']">
                    {{ item.state | mapTextStatus(listStatusContract) }}
                  </span>
                  <div
                    v-if="
                      item.state && (item.state === 'REJECTED_SA' || item.state === 'REJECTED_MA')
                    "
                  >
                    <p
                      class="form-control-plaintext f12"
                      v-if="
                        item.reasonRejected && item.reasonRejected[item.reasonRejected.length - 1]
                      "
                    >
                      {{
                        item.reasonRejected
                          ? item.reasonRejected[item.reasonRejected.length - 1]
                          : ''
                      }}
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'

  export default {
    props: ['dataContract'],
    data() {
      return {
        listStatusContract: Config.listStatusContract,
      }
    },
    methods: {},
  }
</script>

<style scoped></style>
